const sendAnalyticEvent = (event) => {
  if (window._mtm) {
    window._mtm.push(event);
  }
};
export {
  sendAnalyticEvent
};
